@if (!loading) {
  <p-dialog [modal]="true"
            [(visible)]="transactionDetailsDialog.visible"
            [style]="{width: '50rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false"
            [focusOnShow]="false"
            (visibleChange)="$event === false ? closeDetailsDialog() : null">
    <ng-template pTemplate="header">
      <div class="text-lg font-bold">
        {{ transactionDetailsHeader }}
      </div>
    </ng-template>
    @if (transactionDetailsDialog.visible) {
      <sps-transaction-details-dialog [transactionViewMode]="transactionViewMode"
                                      [transactionId]="selectedTransaction.id"
                                      [showTransactionError]="showTransactionError"
                                      [transactionErrorMessage]="transactionErrorMessage"
                                      (transactionIdChanged)="onTransactionIdChanged($event)"
                                      (processCapture)="onProcessCapture($event)"
                                      (processVoid)="onProcessVoid($event)"
                                      (refundSuccessful)="onRefundSuccessful()"
                                      (creditSuccessful)="onCreditSuccessful()"
                                      titleColumnWidth="200px">
      </sps-transaction-details-dialog>
    }
    <ng-template #footer class="pt-3">
      <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeDetailsDialog()"/>
    </ng-template>
  </p-dialog>
  <p-card class="h-full">
    <ng-template pTemplate="title">
      <div class="flex flex-1 gap-2 align-self-stretch align-items-center">
        <div class="flex flex-1 align-items-center gap-3">
          <p-select-button [options]="stateOptions"
                           [(ngModel)]="currentState"
                           [allowEmpty]="false"
                           optionLabel="label"
                           optionValue="value"
                           [attr.aria-label]="i18n.i18nLng()['STATE']"
                           (onChange)="tableStatusChanged()">
          </p-select-button>
          <div style="word-break: keep-all">{{ i18n?.i18nLng()['LATESTTRANS'] }}</div>
        </div>
      </div>
    </ng-template>
    @if (model.length === 0) {
      <db-no-data-info i18nMessageKey="NOTRANSACTIONSDATA"></db-no-data-info>
    } @else {
      <p-table [value]="model"
               class="mt-2"
               [selectionMode]="'single'"
               [(selection)]="selectedTransaction"
               (onRowSelect)="onRowSelected($event)">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>{{ i18n?.i18nLng()['DATEANDTIME'] }}</th>
            <th>{{ i18n?.i18nLng()['PURPOSE'] }}</th>
            <th class="text-right">{{ i18n?.i18nLng()['AMOUNTGROSS'] }}</th>
            <th>{{ i18n?.i18nLng()['STATE'] }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-trans>
          <tr [pSelectableRow]="trans">
            <td class="large-icon-cell">
              @switch (trans.paymentMethod) {
                @case ('CREDITCARD_MOTO') {
                  <sps-custom-icon name="creditcard_moto" [alt]="i18n.i18nLng()['CREDITCARD_MOTO']" [size]="21"></sps-custom-icon>
                }
                @case ('WERO') {
                  <sps-custom-icon name="wero" alt="Wero" [size]="21"></sps-custom-icon>
                }
                @case ('SEPA') {
                  <sps-custom-icon name="sepa" alt="Sepa" [size]="21"></sps-custom-icon>
                }
                @case ('SEPA_BLACKLIST') {
                  <sps-custom-icon name="sepa_blacklist" alt="Sepa mit Sperrdatei" [size]="21"></sps-custom-icon>
                }
                @case ('KLARNA') {
                  <sps-custom-icon name="klarna" alt="Klarna" [size]="21"></sps-custom-icon>
                }
                @case ('DIRECTTRANSFER') {
                  <sps-custom-icon name="directtransfer" alt="Direct Transfer" [size]="21"></sps-custom-icon>
                }
                @default {
                  <i [ngClass]="trans.paymentMethod | keyToIcon"></i>
                }
              }
            </td>
            <td class="date-time-cell">
              {{ trans.date | date : 'dd.MM.yyyy - HH:mm' }}
            </td>
            <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
              {{ trans.purpose }}
            </td>
            <td class="text-right font-bold amount-cell">
              {{ trans.amount | amountCurrencyDisplay: trans.currency : 100 }}
            </td>
            <td>
              @if (trans.status === 'successful') {
                <p-tag [value]="i18n.i18nLng()['SUCCESSFUL']" severity="success" icon="pi pi-check"/>
              }
              @if (trans.status === 'canceled') {
                <p-tag [value]="i18n.i18nLng()['NOTSUCCESSFUL']" severity="danger" icon="pi pi-exclamation-triangle"/>
              }
              @if (trans.status === 'initialized') {
                <p-tag [value]="i18n.i18nLng()['INITIALIZED']" severity="secondary" icon="pi pi-plus"/>
              }
            </td>
            <td class="table-toggler-icon align-items-center" style="width: 28px">
              <i class="pi pi-chevron-right"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </p-card>
} @else {
  <p-card [header]="i18n?.i18nLng()['LATESTTRANS']" class="card-secondary">
    <div class="flex flex-1 justify-content-center p-4">
      <i class="pi pi-spin pi-spinner text-3xl text-color-secondary"></i>
    </div>
  </p-card>
}

